export const buttonVariants = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERNARY: 'ternary',
  SELECTED: 'selected',
  ROUNDED: 'rounded',
  ROUNDED_NOTIFY_POSITIVE: 'roundedNotifyPositive',
  ROUNDED_NOTIFY_NEGATIVE: 'roundedNotifyNegative',
  ROUNDED_NOTIFY_PENDING: 'roundedNotifyPending',
  TEXT: 'text',
  TEXTBLUE: 'textBlue',
  FULL_ROUNDED: 'fullRounded',
  DISABLED: 'disabled',
  NAVY_WHITE: 'navyWhite',
  NAVY_BLUE: 'navyBlue',
  LIGHT_GREY: 'lightGrey',
  LIGHT_BLUE: 'lightBlue',
  RED_PRIMARY: 'redPrimary'
};

export const buttonSizes = {
  SMALL: 'small',
  XSMALL: 'xsmall',
  XMEDIUM: 'xmedium',
  MEDIUM: 'medium'
};
